import * as z from 'zod';
import { ShipsStructure } from '../../reportsTypes';
import { shipSchema } from './createDynamicFilterZodSchema';

/**
 * Creates a dynamic Zod schema for ship selection fields.
 * Used when a report type has a ships configuration.
 *
 * @param shipsConfig - The ships configuration from the report type
 * @returns A Zod object schema with ships and shipAttribute fields
 */
export function createDynamicShipsZodSchema(
  shipsConfig: ShipsStructure | null | undefined
) {
  const schemaFields: Record<string, z.ZodTypeAny> = {};

  // If no ships config, return empty schema
  if (!shipsConfig) {
    return z.object(schemaFields);
  }

  // Add ships array field (optional, can be empty array)
  schemaFields['ships'] = z.array(shipSchema).optional().default([]);

  // Add shipAttribute field if either colorBy or filterBy is enabled
  if (shipsConfig.colorBy || shipsConfig.filterBy) {
    // Build enum values based on what's enabled
    const allowedValues: ('colorBy' | 'filterBy')[] = [];
    if (shipsConfig.filterBy) allowedValues.push('filterBy');
    if (shipsConfig.colorBy) allowedValues.push('colorBy');

    if (allowedValues.length === 1) {
      // Only one option, use literal
      schemaFields['shipAttribute'] = z.literal(allowedValues[0]);
    } else {
      // Multiple options, use enum
      schemaFields['shipAttribute'] = z.enum(['filterBy', 'colorBy']);
    }
  }

  return z.object(schemaFields);
}
